import { buildAdditionalContactCard } from './additionalContactCard';

export const otherContactCard = buildAdditionalContactCard({
  contactType: 'other',
  contactLabel: 'Other',
});
